module.exports = __webpack_public_path__ + "static/news-events-1-b240c72685227a04d18a8a3cd6a3b9b8.jpg";